const nodeSourceOptions = {
  ACT: true,
  SAT: true,
  CCSS: true,
  MP: true,
}

export default nodeSourceOptions


// WEBPACK FOOTER //
// ./src/config/nodeSourceOptions.js